export default __webpack_public_path__ + "static/media/notification.8bb6460d.svg";